// Keep this switch in code so the original merchant UI remains available.
export const USE_NEW_APPLICATION_FLOW = true;
export const usesNewApplicationFlow = isCheckout =>
  USE_NEW_APPLICATION_FLOW && !isCheckout;

// The rep wizard in CRM Links uses the same new steps; the old one stays here.
export const USE_NEW_REP_FLOW = true;

// The CRM submit form shows the new steps for the merchant's data and the
// new look on its own steps; the old form stays here.
export const USE_NEW_SUBMIT_FLOW = true;
